export function EuroIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_909_11391)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.75 2.5C6.64 2.5 2.5 6.64 2.5 11.75C2.5 16.86 6.64 21 11.75 21C16.86 21 21 16.86 21 11.75C21 6.64 16.86 2.5 11.75 2.5ZM1 11.75C1 5.81 5.81 1 11.75 1C17.69 1 22.5 5.81 22.5 11.75C22.5 17.69 17.69 22.5 11.75 22.5C5.81 22.5 1 17.69 1 11.75Z"
          fill="#0C0C14"
        />
        <path
          d="M13.1001 12.6599H8.57007C8.16007 12.6599 7.82007 12.3199 7.82007 11.9099C7.82007 11.4999 8.16007 11.1599 8.57007 11.1599H13.1001C13.5101 11.1599 13.8501 11.4999 13.8501 11.9099C13.8501 12.3199 13.5101 12.6599 13.1001 12.6599Z"
          fill="#0C0C14"
        />
        <path
          d="M14.4901 16.42H8.87012C8.46012 16.42 8.12012 16.08 8.12012 15.67C8.12012 15.26 8.46012 14.92 8.87012 14.92C8.97012 14.92 9.02012 14.9 9.09012 14.83C9.30012 14.62 9.55012 14.03 9.53012 12.41L9.50012 9.63996C9.49012 8.95996 9.75012 8.31996 10.2301 7.82996C10.7101 7.33996 11.3501 7.07996 12.0301 7.07996H12.8001C13.5001 7.07996 14.1801 7.37996 14.6501 7.88996C14.9301 8.18996 14.9101 8.66996 14.6101 8.94996C14.3101 9.22996 13.8301 9.20996 13.5501 8.90996C13.3501 8.69996 13.0901 8.57996 12.8001 8.57996H12.0301C11.7501 8.57996 11.4901 8.68996 11.3001 8.88996C11.1101 9.08996 11.0001 9.34996 11.0101 9.62996L11.0401 12.41C11.0401 13.22 11.0101 14.16 10.7401 14.93H14.5001C14.9101 14.93 15.2501 15.27 15.2501 15.68C15.2501 16.09 14.9101 16.43 14.5001 16.43L14.4901 16.42Z"
          fill="#0C0C14"
        />
      </g>
      <defs>
        <clipPath id="clip0_909_11391">
          <rect
            width="21.5"
            height="21.5"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
